<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<div class="flex">
			<h1>Users</h1>
			<div class="flex-grow text-right">
				<button v-on:click="add_user = true;">Add user</button>
			</div>
		</div>

		<Modal v-if="add_user" v-on:close="add_user = false;">
			<h1>Create user</h1>

			<div class="margin-top">
				<div class="margin-bottom">
					<MaterialText label="Email" v-model="create.email" v-on:enter="createUser()" />
				</div>
				<div class="margin-bottom">
					<MaterialText label="First name" v-model="create.first_name" v-on:enter="createUser()" />
				</div>
				<div class="margin-bottom">
					<MaterialText label="Last name" v-model="create.last_name" v-on:enter="createUser()" />
				</div>
				<div class="margin-bottom">
					<MaterialText label="Password" v-model="create.password" v-on:enter="createUser()" />
				</div>
			</div>
			<div class="margin-top">
				<button :disabled="saving" v-on:click="createUser()">Create user</button>
			</div>
		</Modal>

		<div class="margin-top">
			<Table :columns="columns" :rows="records" />
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    add_user: false,
    loading: false,
    saving: false,
    records: [],
    columns: {
      id: {},
      email: {},
      shortened_name: {},
      country: {
        type: 'flag'
      }
    },
    create: {}
  }),
  methods: {
    createUser () {
      Vue.$api.post('/stylist', this.create, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => {
          this.create = {}
          this.add_user = false

          this.load()
        }
      })
    },
    load () {
      Vue.$api.get('/stylists', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.records = data.map(row => {
        row.country = row.country_id

        row.menu = [
          {
            name: 'View',
            url: '/#/user/' + row.id
          }
        ]

        if (!row.active_account) {
          row.options = {
            disabled: true
          }
        }

        return row
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
